export default "__VITE_ASSET__bgi0aQgd__"